module.exports = __webpack_public_path__ + "static/media/eway-dark.bbf15466.svg";